import React, { useEffect } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';

const CustomAlert = ({ type, message, onClose, duration = 5000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  if (!message) return null;

  const isSuccess = type === 'success';

  return (
    <div className="fixed top-4 right-4 z-50 flex items-center justify-between w-full max-w-sm p-4 text-gray-800 bg-white rounded-lg shadow-lg border-l-4 border-t border-b border-r transition-all duration-300 ease-in-out transform translate-y-0"
         style={{ borderLeftColor: isSuccess ? '#10B981' : '#EF4444' }}>
      <div className="flex items-center">
        {isSuccess ? (
          <CheckCircle className="w-6 h-6 text-green-500 mr-3" />
        ) : (
          <XCircle className="w-6 h-6 text-red-500 mr-3" />
        )}
        <p className="text-sm font-medium">{message}</p>
      </div>
      <button onClick={onClose} className="ml-4 text-gray-400 hover:text-gray-600 transition-colors">
        <X className="w-5 h-5" />
      </button>
    </div>
  );
};

export default CustomAlert;
